import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { Button } from "@rio-cloud/rio-uikit";

interface AlertsRecentCardSkeletonProps {
  items?: number;
  className?: string;
}

const HEADER_ICON_SIZE = 20;
const HEADER_TITLE_LINE_HEIGHT = 26;
const HEADER_TITLE_WIDTH = 150;
const HEADER_COUNTER_SIZE = 50;

const ROW_ICON_SIZE = 14;
const ROW_LABEL_LINE_HEIGHT = 20;
const ROW_COUNTER_SIZE = 30;

const BUTTON_LABEL_LINE_HEIGHT = 20;
const BUTTON_LABEL_WIDTH = 60;

const COUNTER_RADIUS = 6;

const ROW_LABEL_WIDTHS = [170, 190, 100];

const DIVIDER_STYLE = { borderTop: "1px solid #E5EBF0" } as const;

const DEFAULT_CARD_CLASS_NAME =
  "padding-10 padding-25-sm display-flex flex-column gap-10 gap-20-sm height-100pct border-style-solid border-color-danger border-width-3 border-left-only";

export default function AlertsRecentCardSkeleton({
  items = 3,
  className = DEFAULT_CARD_CLASS_NAME,
}: Readonly<AlertsRecentCardSkeletonProps>) {
  const rows = Array.from({ length: Math.max(0, items) }, (_, index) => ({
    key: `alerts-recent-skeleton-row-${index}`,
    labelWidth: ROW_LABEL_WIDTHS[index % ROW_LABEL_WIDTHS.length],
  }));

  return (
    <Card className={className}>
      <div className="display-flex align-items-center gap-15">
        <ContentLoader className="flex-0" height={HEADER_ICON_SIZE} width={HEADER_ICON_SIZE} />
        <span className="flex-1-1 min-width-0 text-size-16 text-size-20-sm text-uppercase text-medium">
          <ContentLoader className="display-block" height={HEADER_TITLE_LINE_HEIGHT} width={HEADER_TITLE_WIDTH} />
        </span>
        <ContentLoader
          className="flex-0"
          height={HEADER_COUNTER_SIZE}
          width={HEADER_COUNTER_SIZE}
          rx={COUNTER_RADIUS}
          ry={COUNTER_RADIUS}
        />
      </div>

      <div className="display-flex flex-column gap-10 flex-1-1">
        {rows.map((row) => (
          <div key={row.key} className="display-flex flex-column gap-10">
            <div className="display-flex align-items-center gap-15">
              <ContentLoader className="flex-0" height={ROW_ICON_SIZE} width={ROW_ICON_SIZE} />
              <span className="flex-1-1 min-width-0 text-size-14">
                <ContentLoader className="display-block" height={ROW_LABEL_LINE_HEIGHT} width={row.labelWidth} />
              </span>
              <ContentLoader
                className="flex-0"
                height={ROW_COUNTER_SIZE}
                width={ROW_COUNTER_SIZE}
                rx={COUNTER_RADIUS}
                ry={COUNTER_RADIUS}
              />
            </div>
            <div style={DIVIDER_STYLE} />
          </div>
        ))}
      </div>

      <div className="display-flex justify-content-end">
        <Button bsStyle="primary" disabled>
          <span>
            <ContentLoader className="display-block" height={BUTTON_LABEL_LINE_HEIGHT} width={BUTTON_LABEL_WIDTH} />
          </span>
          <span className="rioglyph rioglyph-arrow-right margin-left-10" aria-hidden="true" />
        </Button>
      </div>
    </Card>
  );
}
